import { render, staticRenderFns } from "./loker.vue?vue&type=template&id=887e6eae&scoped=true"
import script from "./loker.vue?vue&type=script&lang=js"
export * from "./loker.vue?vue&type=script&lang=js"
import style0 from "./loker.vue?vue&type=style&index=0&id=887e6eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887e6eae",
  null
  
)

export default component.exports